<template>
  <div class="page-heading">
    <div class="row">
      <div class="col-md-12">
        <h2>Trip Request</h2>
      </div>
    </div>
    <div class="nav nav-tabs partner-nav" id="nav-tab" role="tablist">
      <router-link :to="{ name: 'vehicle-request' }" class="nav-link"
        >Trip Request
      </router-link>
      <!-- <router-link to="/trip-request/trip/requests" class="nav-link"
        >Trip Request
      </router-link> -->
      <router-link to="/trip-request/backup/requests" class="nav-link"
        >Backup Request
      </router-link>
    </div>

    <router-link
      v-if="pageName === 'trip-request'"
      to="/trip-request/trip/create"
      class="btn btn-primary"
      style="margin-left: 15px"
      >Create Trip Request
    </router-link>
    <div v-if="pageName !== 'vehicle-request'" class="date-holder">
      <Datepicker
        v-model="dateRange"
        range
        :enableTimePicker="false"
        placeholder="Select Date Range"
      />
    </div>

    <div class="filter-section" style="float: right">
        
      <button
        class="btn btn-primary"
        id="filterButton"
        type="button"
        @click="showFilterOptions = !showFilterOptions"
      >
        <i class="bi bi-sliders"></i> Filter
        <span
          v-if="numOfCurrentFilters > 0"
          class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info"
        >
          {{ numOfCurrentFilters }}
        </span>
      </button>
      <div
        v-if="showFilterOptions"
        id="filterPopUp"
        :class="{
          'filter-pop-up': true,
          'wide-pop-up': pageName === 'vehicle-request'
        }"
      >

        <div class="filter-pop-up-close">
          <i @click="showFilterOptions = false" class="bi bi-x-lg"></i>
        </div>
        <label for=""><b>Filter Options</b></label>
        <Multiselect
          :class="{
            'filter-fields': true,
            'filter-options': true,
            'ma-bo-120': filterOptOpen
          }"
          v-model="selectedFilters"
          mode="tags"
          :closeOnSelect="false"
          :searchable="true"
          :createTag="true"
          :options="filterOptions"
          :resetAfter="true"
          @open="filterOptOpen = true"
          @close="filterOptOpen = false"
          label="name"
          track-by="name"
          placeholder="Add Filter"
        />

        <div v-if="selectedFilters.includes('global_search')">
          <label for="">Global Search</label>
          <input
            v-model="filterValues.global_search"
            class="form-control filter-fields"
            placeholder="Search"
            @keydown.enter="search()"
          />
        </div>
        <div
          v-if="
            pageName !== 'vehicle-request' && selectedFilters.includes('status')
          "
        >
          <label for="">Status</label>
          <select
            class="form-select filter-fields"
            v-model="filterValues.status"
            @keydown.enter="search()"
          >
            <option value="">All</option>
            <option value="Published">Published</option>
            <option value="Unpublished">Unpublished</option>
            <option value="Closed">Closed</option>
          </select>
        </div>
        <div v-if="selectedFilters.includes('backup_request_code')">
          <label for="">Backup Request Code</label>
          <input
            v-model="filterValues.backup_request_code"
            class="form-control filter-fields"
            placeholder="Backup Request Code"
            @keydown.enter="search()"
          />
        </div>

        <div v-if="pageName === 'vehicle-request'" class="row">
          <div class="col-sm-6" v-if="selectedFilters.includes('routeName')">
            <label for="">Route Name</label>
            <input
              type="text"
              v-model="filterValues.routeName"
              class="form-control filter-fields"
              placeholder="Route Name"
              @keydown.enter="search()"
            />
          </div>
          <div
            class="col-sm-6"
            v-if="selectedFilters.includes('requestedDate')"
          >
            <label for="">Requested Date</label>
            <input
              type="date"
              v-model="filterValues.requestedDate"
              class="form-control filter-fields"
              placeholder="Requested Date"
              @keydown.enter="search()"
            />
          </div>
          <div class="col-sm-6" v-if="selectedFilters.includes('distance')">
            <label for="">Total Distance</label>
            <input
              type="text"
              v-model="filterValues.distance"
              class="form-control filter-fields"
              placeholder="Total Distance"
              @keydown.enter="search()"
            />
          </div>
          <div class="col-sm-6" v-if="selectedFilters.includes('time')">
            <label for="">Time</label>
            <input
              type="time"
              v-model="filterValues.time"
              class="form-control filter-fields"
              placeholder="Time"
              @keydown.enter="search()"
            />
          </div>
          <div class="col-sm-6" v-if="selectedFilters.includes('companyCode')">
            <label for="">Company</label>
            <input
              v-model="filterValues.companyCode"
              class="form-control filter-fields"
              placeholder="Company"
              @keydown.enter="search()"
            />
          </div>
          <div class="col-sm-6" v-if="selectedFilters.includes('dutyDays')">
            <label for="">Duty Days</label>
            <input
              type="text"
              v-model="filterValues.dutyDays"
              class="form-control filter-fields"
              placeholder="Duty Days"
              @keydown.enter="search()"
            />
          </div>
          <div
            class="col-sm-6"
            v-if="selectedFilters.includes('dutyStartDate')"
          >
            <label for="">Duty Start Date</label>
            <input
              type="date"
              v-model="filterValues.dutyStartDate"
              class="form-control filter-fields"
              placeholder="Duty Start Date"
              @keydown.enter="search()"
            />
          </div>
          <div class="col-sm-6" v-if="selectedFilters.includes('serviceType')">
            <label for="">Service Type</label>
            <select
              class="form-select filter-fields"
              v-model="filterValues.serviceType"
              @keydown.enter="search()"
            >
              <option value="">All</option>
              <template v-for="tripType in tripTypes" :key="tripType.id">
                <option :value="tripType.name">{{ tripType.name }}</option>
              </template>
            </select>
          </div>
          <div class="col-sm-6" v-if="selectedFilters.includes('vehicleType')">
            <label for="">Vehicle Type</label>
            <input
              type="text"
              v-model="filterValues.vehicleType"
              class="form-control filter-fields"
              placeholder="Vehicle Type"
              @keydown.enter="search()"
            />
          </div>
          <div class="col-sm-6" v-if="selectedFilters.includes('modality')">
            <label for="">Modality</label>
            <select class="form-select" v-model="filterValues.modality">
              <option value="">--Select--</option>
              <option value="pool">Pool</option>
              <option value="fleet-fixed">Fleet Fixed</option>
              <option value="fleet-variable">Fleet Variable</option>
            </select>
            <!-- <input
              type="text"
              v-model="filterValues.modality"
              class="form-control filter-fields"
              placeholder="Modality"
              @keydown.enter="search()"
            /> -->
          </div>
          <div class="col-sm-6" v-if="selectedFilters.includes('requestedBy')">
            <label for="">Requested By</label>
            <input
              type="text"
              v-model="filterValues.requestedBy"
              class="form-control filter-fields"
              placeholder="Requested By"
              @keydown.enter="search()"
            />
          </div>
          <div class="col-sm-6" v-if="selectedFilters.includes('status')">
            <label for="">Status</label>
            <select
              v-model="filterValues.status"
              class="form-select filter-fields"
              placeholder="Status"
              @keydown.enter="search()"
            >
              <option value="">--Select--</option>
              <option value="Requested">Requested</option>
              <option value="Accepted">Accepted</option>
              <option value="Assigned">Assigned</option>
              <option value="Reviewed">Reviewed</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>
          <div
            class="col-sm-6"
            v-if="selectedFilters.includes('assignedDriver')"
          >
            <label for="">Assigned Driver</label>
            <input
              type="text"
              v-model="filterValues.assignedDriver"
              class="form-control filter-fields"
              placeholder="Assigned Driver"
              @keydown.enter="search()"
            />
          </div>
        </div>

        <!-- Search Button -->
        <button @click="search()" class="btn btn-sm btn-primary">
          <i class="bi bi-search"></i> Search
        </button>
      </div>
    </div>
    <select
      v-if="pageName !== 'vehicle-request'"
      class="form-select filter-fields"
      style="width: 110px; float: right"
      v-model="filterValues.service_type"
      @keydown.enter="search()"
    >
      <option value="">All</option>
      <template v-for="tripType in tripTypes" :key="tripType.id">
        <option :value="tripType.id">{{ tripType.name }}</option>
      </template>
    </select>

   

    <template v-if="pageName === 'vehicle-request'">
      <button
        v-if="downloadingTripList"
        class="btn btn-download"
        type="button"
        disabled
      >
        <i class="bi bi-download"></i> Downloading...
      </button>
      <button
        v-else
        class="btn btn-download"
        type="button"
        @click="$emit('downloadTripList')"
      >
        <i class="bi bi-download"></i> Download
      </button>
    </template>

    <div v-if="pageName === 'vehicle-request'" class=" filter-fields"
      style="width: 210px; float: right">
        <!-- <label for="">TR Id</label> -->
        <Multiselect
        class="filter-fields"
        v-model="filterValues.trId"
        :closeOnSelect="true"
        :searchable="true"
        :options-limit="20"
        :options="TRIdList"
        :loading="true"
        placeholder="Select TR"
        />
    </div>
    
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';
import http from '../../config/axios';
import Datepicker from '@vuepic/vue-datepicker';
import moment from 'moment';

export default {
  components: {
    Multiselect,
    Datepicker
  },
  props: ['pageName', 'filterOptions', 'downloadingTripList'],
  data() {
    return {
      showFilterOptions: false,
      numOfCurrentFilters: 0,
      filterOptOpen: false,
      tripTypes: [],
      selectedFilters: [],
      TRIdList: [],
      filterValues: {
        global_search: '',
        status: '',
        service_type: '',
        backup_request_code: '',
        start_date: null,
        end_date: null,
        routeName: '',
        requestedDate: '',
        distance: '',
        time: '',
        companyCode: '',
        dutyDays: '',
        dutyStartDate: '',
        serviceType: '',
        vehicleType: '',
        modality: '',
        requestedBy: '',
        assignedDriver: '',
        trId:''
      },
      dateRange: null
    };
  },
  mounted() {
    this.getTripType();
    this.fillFilterValuesFromRoute();
    this.getTripRequests();
  },
  watch: {
    selectedFilters: function () {
      this.filterValueMapping();
    },
    'filterValues.trId': function () {
      this.$emit('filterData', this.filterValues);
    },
    'filterValues.service_type': function () {
      this.$emit('filterData', this.filterValues);
    },
    dateRange: function () {
      this.filterValues.start_date = null;
      this.filterValues.end_date = null;
      if (this.dateRange && this.dateRange.length > 0) {
        this.filterValues.start_date = moment(this.dateRange[0]).format(
          'YYYY-MM-DD'
        );
        this.filterValues.end_date = moment(this.dateRange[1]).format(
          'YYYY-MM-DD'
        );
      }
      this.search();
    }
  },
  methods: {
    filterValueMapping() {
      let oldFilterValues = {};

      for (const key in this.filterValues) {
        oldFilterValues[key] = this.filterValues[key];
        this.filterValues[key] = '';
      }

      this.selectedFilters.forEach((ele) => {
        this.filterValues[ele] = oldFilterValues[ele];
      });
    },
    getTripType() {
      http.get('v2/trips/types').then((res) => {
        this.tripTypes = res.data.data;
      });
    },
    search(page_no = 1) {
      this.numOfCurrentFilters = this.selectedFilters.length;
      this.showFilterOptions = false;
      this.$emit(
        'filterData',
        this.filterValues,
        this.selectedFilters,
        page_no
      );
    },
    fillFilterValuesFromRoute() {
      if (this.$route.params.filter_data) {
        this.selectedFilters = [];
        let filterValues = {};
        let filterString = this.$route.params.filter_data.split('&');

        filterString.forEach((element) => {
          let splittedElement = element.split('=');
          if (splittedElement?.length === 2) {
            let key = decodeURIComponent(splittedElement[0]);
            let value = decodeURIComponent(splittedElement[1]);
            filterValues[key] = value;
          }
        });

        for (const key in filterValues) {
          if (this.filterValues[key] !== undefined) {
            this.selectedFilters.push(key);
            this.filterValues[key] = filterValues[key];
          }
        }

        this.search(
          this.$route.params.page_number ? this.$route.params.page_number : 1
        );
      }
    },
    getTripRequests() {
      http
        .get(
          `v2/partners/triprequests?pagination_value=500&page=1&routeName=&requestedDate=&distance=&time=&companyCode=&dutyDays=&dutyStartDate=&serviceType=${this.filterValues.serviceType}&vehicleType=&modality=${this.filterValues.modality}&requestedBy=&status=`
          // &assignedDriver=${this.filterValues.assignedDriver}
        )
        .then((response) => {
          let trLists = response.data.data.data;
            this.TRIdList.push(
                {
                value: "",
                label: ""
                }
            );
            trLists.forEach(res=>{
                this.TRIdList.push(
                    {
                    value: res.id,
                    label: res.trip_code
                    }
                );
            });
          
        })
    }
  }
};
</script>

<style scoped>
.page-heading h2 {
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 16px !important;
}

/* Filter CSS */
.filter-section {
  position: relative;
  margin-left: 15px;
}
.filter-pop-up {
  position: absolute;
  right: 0;
  top: 45px;
  background: #fff;
  width: 350px;
  padding: 10px 10px 20px 10px;
  box-shadow: 0px 13px 31px 2px rgb(0 0 0 / 16%);
  border-radius: 4px;
  z-index: 20;
}
.wide-pop-up {
  width: 550px;
}
.filter-pop-up label {
  font-size: 14px;
  font-weight: normal;
}
.filter-pop-up .filter-fields {
  margin-bottom: 15px;
}
.filter-pop-up button {
  float: right;
}
.filter-pop-up-close {
  overflow: hidden;
}
.filter-pop-up-close i {
  float: right;
  cursor: pointer;
}
.date-holder {
  float: right;
  width: 250px;
  margin-left: 15px;
}
#filterButton {
  background: rgba(101, 47, 143, 0.15);
  color: #652f8f;
  border: none;
}
#filterButton:hover {
  background: #652f8f;
  color: #fff;
}
.btn-download {
  color: #652f8f;
  font-size: 16px;
  font-weight: 500;
}
.btn-download:hover {
  color: #a95eea;
}
</style>
